// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] + "-" + {"218":"6513c16d5b98cf5ffda5","532":"563007291e8aa0292b84","691":"a0e53a1a600e819ae62f","774":"e41fea7e2bad2f453dc7"}[chunkId] + ".js";
};